import React, { Component } from 'react';
import Header from '../Layouts/Header';

import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import {apiUrl ,tapURL,cmsURL,mediaUrl } from "../Config/Config";
import Axios from 'axios';
import { withRouter } from 'react-router-dom';

import ReactJson from 'react-json-view';
import $ from 'jquery';

class View extends Component {
  
  constructor(props)
  {
    super(props); 
    //const colorid = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

     const companyid = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
    // console.log(colorid,'colorid')
    this.state = {      
      companyid: companyid,
      cmslist:'',
      cmsgalleries: [],
    jsonId:'',
    isCategory:'',
    jsonDetails: {},
    fileList: [],
    expanded: false,
    editMode: false,
    jsonContent: {},
    functionalEndpoints: false,
    };
 let admin_id = localStorage.getItem("admin_id");
    var qs = require('qs');
    var postObject = {             
    cat_id   :companyid,
    admin_id :admin_id
   
    };
    this.handleJsonEdit = this.handleJsonEdit.bind(this);
          Axios.post(apiUrl + "jsonaifeed/listdetail", qs.stringify(postObject)).then(res => {
          if (res.data.status === 'success') {
            const categoryData = res.data.categories[0]; 
            var endpoint_st;
            if(categoryData.endpoint === 'yes') {
                endpoint_st = true;	
            }	else {
              endpoint_st = false;	
            }	
            this.setState({
              categoryTitle: categoryData.category_title,
              fileList: categoryData.files,
              functionalEndpoints: endpoint_st,
              isCategory: true,            
              expanded: false              
            });
          } else {
            this.setState({
              categoryTitle: '',
              fileList: [],
              isCategory: false
            });
          }
        });
  }

   
   componentDidMount() {
     document.title = PageTitle('Product View');
   }

   componentDidUpdate(prevProps,prevState){

   }
   highlightEndpoints = (obj) => {
  if (typeof obj !== 'object' || obj === null) return obj;

  const newObj = Array.isArray(obj) ? [] : {};

  for (let key in obj) {
    if (key === 'endpoint') {
      newObj[key] = (
        <span style={{ color: 'yellow', background: 'black', fontWeight: 'bold', padding: '2px 4px' }}>
          {obj[key]}
        </span>
      );
    } else if (typeof obj[key] === 'object') {
      newObj[key] = this.highlightEndpoints(obj[key]); // recurse for nested objects
    } else {
      newObj[key] = obj[key];
    }
  }

  return newObj;
};

   handleJsonEdit = (edit) => {

      this.setState({ jsonContent: edit.updated_src });

      var qs = require('qs');
      const postObject = {
        file_name: this.state.editingFileName,
        json_content:  edit.updated_src,
      };

    
     Axios.post(apiUrl + "jsonaifeed/updateJsonFile", qs.stringify(postObject)).then(res => {
          if (res.data.status === 'success') {

            $('.success_message').html('<div class="status_sucess"><h3>'+'JSON file updated successfully!'+'</h3></div>');
            setTimeout(
								function() {
									$('.success_message').html('');
								}
								.bind(this),
								3000
								);
            this.setState({ editMode: false });
          } else {
             $('.success_message').html('<div class="status_sucess"><h3>'+'JSON file updated successfully!'+'</h3></div>');
            
          }
        })
        .catch((error) => {
          console.error('Error updating JSON:', error);
        });
  };

saveUpdatedJson = () => {
      
    };
   componentWillReceiveProps(Props){
      if(Props.companylistview!==this.state.companylistview){
        if(Props.productlistview[0].status == "success"){
          this.setState({companylistview: Props.companylistview[0].companylistview[0]}) 
        }
      }

    
   }

   
  stripHtmlTags(html) {
    if (!html) {
      return '';
    }
    const regex = /(<([^>]+)>)/ig;
    return html.replace(regex, '');
  }
fetchJsonFileContent = (fileName) => {

   if (this.state.editingFileName === fileName) {
    // if already open, close it
    this.setState({ editingFileName: null });
  } else {

   var qs = require('qs');
  const postObject = { file_name: fileName };
  Axios.post(apiUrl + "jsonaifeed/getJsonFile", qs.stringify(postObject))
    .then(res => {
      try {
        const parsedJson = JSON.parse(res.data.content);  // content should be stringified JSON
        this.setState({
          jsonContent: parsedJson,
          editingFileName: fileName
        });
      } catch (error) {
        alert("Invalid JSON format in file.");
      }
    })
    .catch(error => {
      console.error('Error fetching JSON content:', error);
    });
  }
};

saveUpdatedJson = (fileName) => {
  var qs = require('qs');
  const postObject = {
    file_name: fileName,
    json_content: this.state.jsonContent,
  };

  Axios.post(apiUrl + "jsonaifeed/updateJsonFile", qs.stringify(postObject))
    .then(res => {
      if (res.data.status === 'success') {
        this.setState({
          isJsonDirty: false,
          successMessage: 'JSON saved successfully!'
        });

        setTimeout(() => {
          this.setState({ successMessage: '' });
        }, 3000);
      }
    })
    .catch(error => {
      console.error('Error saving JSON:', error);
    });
};


render() {
    return (
      <div className="wrapper">
        <Header />
        <MenuSidebar currentpage="cmsjson" />

        <div className="content">
          <div className="content-wrapper">
            <div className="content-body">
              <div className="content-wrapper-before"></div>
              <div className="form-wrapper leaa-admin-head card">
                <div className="success_message"></div>
               <div>
				        <a class="primary-btn" href="/json">Back</a>
			      </div>
                <div className="title">
                  <h3>Json Details</h3>
                </div>

                <div className="form-row">
                  <div className="details_left">

                    {/* Title */}
                    <div className="view-details">
                      <div className="view-details-one">
                        <p><b>{this.state.isCategory ? 'Category Name' : 'JSON Title'}<span>:</span></b></p>
                      </div>
                      <div className="view-details-two">
                        <p>{this.state.categoryTitle
                          ? this.state.categoryTitle.charAt(0).toUpperCase() + this.state.categoryTitle.slice(1)
                          : ''}</p>
                      </div>
                    </div>
                    {/* Multiple Files (Category) */}
                    {this.state.isCategory && (
                      <div className="view-details">
                        <div className="view-details-one">
                          <p><b>Files<span>:</span></b></p>
                        </div>
                        <div className="view-details-two">
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {this.state.fileList.length > 0 ? (
                              this.state.fileList
                                .slice(0, this.state.expanded ? this.state.fileList.length : 3)
                                .map((file) => (
                                  <div key={file.id} className='w-100'>
                                    <div className='d-flex w-100'>
                                    <div className='w-75 d-flex'>
                                    <span className='text-break' >{file.json_file}</span>

                                    <span
                                      onClick={() => this.fetchJsonFileContent(file.json_file)}
                                      // target="_blank"
                                      rel="noopener noreferrer"
                                      className='ms-2 me-2 cursor-pointer'
                                    >
                                      <i className="ft-eye" aria-hidden="true"></i>
                                    </span>
                                  {file.status === 'A' ? (
                                    <span
                                      title="Active"
                                      className='me-2 cursor-pointer'
                                    >
                                      <i className="ft-unlock" aria-hidden="true"></i>
                                    </span>
                                  ) : (
                                    <span
                                      title="Inactive"
                                      className='me-2 cursor-pointer'
                                    >
                                      <i className="ft-lock" aria-hidden="true"></i>
                                    </span>
                                    
                                  )}

                                    </div>

                                          {/* {!this.state.functionalEndpoints && (
                                                <div className='w-25'>
                                                  <button
                                                    className='btn for json'
                                                    onClick={() => this.fetchJsonFileContent(file.json_file)}
                                                    style={{
                                                      marginLeft: '10px',
                                                      padding: '5px 10px',
                                                      cursor: 'pointer',
                                                      fontSize: '12px',
                                                    }}
                                                  >
                                                    {this.state.editingFileName === file.json_file ? 'Editing' : 'Edit JSON'}
                                                  </button>
                                                </div>
                                              )} */}
                                       </div>
                                           

                                        {this.state.editingFileName === file.json_file && (
                                              
                                              <div className='json-editor-container'>
                                                <div className='json-editor-inner'>
                                                <ReactJson
                                                  src={this.state.jsonContent}
                                                   onEdit={this.state.functionalEndpoints ? false : (edit) => this.handleJsonEdit(edit)}
                                                  onAdd={this.state.functionalEndpoints ? false : (add) => this.handleJsonEdit(add)}
                                                  onDelete={this.state.functionalEndpoints ? false : (del) => this.handleJsonEdit(del)}
                                                  // onEdit={(edit) => this.handleJsonEdit(edit)}
                                                  // onAdd={(add) => this.handleJsonEdit(add)}
                                                  // onDelete={(del) => this.handleJsonEdit(del)}
                                                  theme="monokai"
                                                  displayDataTypes={false}
                                                  displayObjectSize={false}
                                                  // collapsed={1}
                                                  className="json-text-editor"
                                                  style={{ padding: '10px', borderRadius: '5px', background: '#2d2d2d' }}
                                                  
                                                
                                                />
                                                </div>
                                              </div> 
                                            )}
                                        </div>
                                        
                                ))
                            ) : (
                              <span>N/A</span>
                            )}
                          </div>

                          {this.state.fileList.length > 3 && (
                            <div style={{ marginTop: '10px' }}>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({ expanded: !this.state.expanded });
                                }}
                                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                              >
                                {this.state.expanded ? 'Show Less' : 'Show More'}
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}


export default (withRouter(View));